export default __webpack_public_path__ + "static/parental-5355a17025d448d232f975a65defd2b3.png";